import { get } from 'lodash';

import type { Breakpoint } from '@hivebrite/design-system/Theme';

/**
  Get the value of an attribute for a specific breakpoint. If the value
  is not defined for the specified breakpoint, fallback to the value for
  the `_` breakpoint. If the value is also not defined for `_` (i.e. the
  input `value` is not an object), return the original value.
 */

export const getBpNum = (
  input: number | Breakpoint,
  breakpoint: keyof Breakpoint,
) => Number(get(input, breakpoint, get(input, '_', input)));
